import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'base64url'
})
export class Base64UrlPipe implements PipeTransform {

  transform(value: string): string {
    return value ? encodeURIComponent(btoa(value)) : value;
  }

}
